export const GET_LIST_SURVEY_BY_RESPONDENT_SUCCESS = 'GET_LIST_SURVEY_BY_RESPONDENT_SUCCESS'

/**
 * It returns an object with two properties: type and content. 
 * 
 * The type property is a string that is the same as the constant
 * GET_LIST_SURVEY_BY_RESPONDENT_SUCCESS. 
 * 
 * The content property is whatever is passed into the function as the content parameter.
 * @param content - {
 * @returns An object with two properties: type and content.
 */
const GetListSurveyByRespondentSuccess = (content) => {
	return {
		type: GET_LIST_SURVEY_BY_RESPONDENT_SUCCESS,
		content
	}
} 


export {
	GetListSurveyByRespondentSuccess, 
}